import * as React from 'react';
import styled from 'styled-components';
import { InlineSvg } from '../Svg';

import { ANIMATION, BREAK_POINTS, COLOURS, TEXT } from '../../consts/style';
import { TrackedLink } from '@origin-digital/ods-core';

const QuickLinkItem = styled(TrackedLink)`
  position: relative;
  box-sizing: border-box;
  height: 120px;
  background: white;
  display: inline-block;
  width: 50%;
  text-align: center;
  text-decoration: none;

  & > span {
    position: relative;
    display: block;
    top: 22px;
    line-height: 1.71;
    font-weight: 400;
    font-size: 14px;
    padding: 0 28px;
    color: ${TEXT.LINK.STATIC};
    text-decoration: none;
  }

  &:hover svg {
    transform: scale(${ANIMATION.ICON.SCALE});
  }

  & svg {
    position: relative;
    top: 0px;
    margin: 0;
    padding: 0;
    height: 36px;
    color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    transition: transform ${ANIMATION.ICON.SPEED};
  }

  @media (min-width: ${BREAK_POINTS.MAX.XS}) {
    & svg {
      top: 14px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MAX.XS}) {
    border-bottom: 1px solid ${COLOURS.GREY.GREY_16};
    &:nth-child(odd) {
      border-right: 1px solid ${COLOURS.GREY.GREY_16};
    }
    &:nth-child(2n + 1):nth-last-child(-n + 2),
    &:nth-child(2n + 1):nth-last-child(-n + 2) ~ a {
      border-bottom: none;
    }
  }

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    width: 25%;
    height: 160px;
    border-right: 1px solid ${COLOURS.GREY.GREY_16};
    vertical-align: middle;
    &:last-child {
      border-right: 0;
    }

    & > span {
      display: block;
      top: 0;
      color: ${TEXT.BODY};
      margin: 22px auto;
      line-height: 1.71;
      font-weight: 400;
      font-size: 14px;
      padding: 0 12px;
    }

    & svg {
      display: block;
      position: relative;
      margin: 0 auto;
      margin-top: 22px;
      padding: 0;
      height: 56px;
      color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
      fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    }
  }
` as any;

export const QuickLink = ({ headline, url, icon }) => {
  return (
    <QuickLinkItem
      href={url}
      trackingType="CustomLink"
      trackingLabel={headline}
      data-comment="QuickLink"
      data-id={`quickLink-${headline}`}
    >
      <InlineSvg html={icon} />
      <span>{headline}</span>
    </QuickLinkItem>
  );
};
